import {
    CHATBOT_CONVERSATION_MESSAGE__FAILURE,
    CHATBOT_CONVERSATION_MESSAGE__REQUEST,
    CHATBOT_CONVERSATION_MESSAGE__SUCCESS,
    CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS,
    CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS,
    NEW_CHATBOT_MESSAGE_FAILURE,
    NEW_CHATBOT_MESSAGE_REQUEST,
    NEW_CHATBOT_MESSAGE_SUCCESS,
    RESET_CHATBOT,
    RESET_INTERACTION_FORM,
    UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS
} from "../../actions/chatbot/constants";

const INITIAL_STATE = {
    fetching: false,
    conversation_id: "",
    data: [],
    error: false,
    company_list: [],
    context_list: [],
    session: {
        fetching: false,
        error: false
    }
};

const appendSelfMessage = (message) => {
    return {
        id: Math.floor(Math.random() * 1000),
        creatd_at: Date.now(),
        message,
        liked: false,
        unliked: false,
        showInteractionForm: false,
        ...(!message && { fetching: true }),
        ...(message && { isSelf: true }) // in case of receiver msg for loader
    }
};

const appendNewMessage = (data, item) => {
    const targetMessage = data.pop();
    if (!item) return data;
    let newData = [...data, {
        ...targetMessage,
        ...item,
        isTyping: item.content ? true : false,
        message: item.content,
        fetching: false,
    }];
    return newData;
};

const updateExistingMessage = (data, item) => {
    return data.map((each) => {
        if (each.id !== item.id) return each;
        return {
            ...each,
            ...item,
        }
    });

}

const updateLike = (data, id) => {
    return data.map((each) => {
        if (each.id !== id) return each;
        return {
            ...each,
            liked: !each.liked
        }
    });
}

const updateUnlike = (data, id) => {
    const lastItemId = data[data.length - 1].id;
    return data.map((each) => {
        if (each.id !== id) return each;
        return {
            ...each,
            unliked: !each.unliked,
            showInteractionForm: lastItemId === id ? true : false,
        }
    });

}

const closeInteractionForm = (data) => {
    const targetMessage = data.pop();
    let newData = [...data, {
        ...targetMessage,
        showInteractionForm: false
    }];
    return newData;
}




export default function view(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHATBOT_CONVERSATION_MESSAGE__SUCCESS:
            return {
                ...state,
                conversation_id: action.payload.conversation_id,
                context_list: action.payload.context_list,
                company_list: action.payload.company_list,
                session: {
                    error: false,
                    fetching: false
                },
                data: [
                    {
                        id: Math.floor(Math.random() * 1000),
                        message: action.payload.content,
                        created_at: action.payload.created_at,
                        isheaderMessage: true,
                    }
                ],
            };

        case CHATBOT_CONVERSATION_MESSAGE__REQUEST:
            return {
                ...state,
                session: {
                    error: false,
                    fetching: true
                }

            };
        case CHATBOT_CONVERSATION_MESSAGE__FAILURE:
            return {
                ...state,
                session: {
                    error: true,
                    fetching: false
                }

            };
        case CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS:
            return {
                ...state,
                data: updateLike(state.data, action.payload.id),
            }
        case CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS:
            return {
                ...state,
                data: updateUnlike(state.data, action.payload.id),
            }
        case NEW_CHATBOT_MESSAGE_REQUEST:
            return {
                ...state,
                data: [
                    ...state.data.map(item => {
                        return {
                            ...item,
                            showInteractionForm: false,
                        }
                    }),
                    appendSelfMessage(action.payload.message),
                    appendSelfMessage(""),
                ]
            };
        case NEW_CHATBOT_MESSAGE_SUCCESS:
            return {
                ...state,
                data: appendNewMessage(state.data, action.payload.data),
            };
        case NEW_CHATBOT_MESSAGE_FAILURE:
            return {
                ...state,
                data: appendNewMessage(state.data, false),
            };
        case UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS:
            return {
                ...state,
                data: updateExistingMessage(state.data, action.payload.data),
            }
        case RESET_CHATBOT:
            return INITIAL_STATE;
        case RESET_INTERACTION_FORM:
            return {
                ...state,
                data: closeInteractionForm(state.data),
            };
        default:
            return state;
    }
}
